import { Suspense } from 'react';
import { PersonSettlements } from '@features';
import { Box, Skeleton } from '@mantine/core';

export const PersonDetailsSettlementsPage: React.FC = () => {
  return (
    <Box py="md">
      <Suspense fallback={<Skeleton height={400} />}>
        <PersonSettlements />
      </Suspense>
    </Box>
  );
};
